

<div class="section">
  <div class="table-header" *ngIf="isSalesCompany">
    <div class="select-all-container align-items-center d-flex flex-row gap-1">
      <mat-checkbox [checked]="isAllSelected()"
                    [indeterminate]="isIndeterminate()"
                    (change)="toggleAllSelection($event.checked)">
      </mat-checkbox>

      <div class="dropdown">
        <button class="btn rounded-5 btn-primary dropdown-toggle" [disabled]="getTotalSelectedItems() == 0" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
          {{selectedText}} ({{ getTotalSelectedItems() }})
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li *ngFor="let status of getFilteredStatuses()">
            <a class="dropdown-item" href="javascript:void(0)" (click)="openApproveOrDenyPopup(status.id)">{{ status.altName }}</a>
          </li>


        </ul>
      </div>

    </div>
  </div>
  <app-review-table [headingText]="'X-RAY IMAGES'"
                    [datasource]="xrayDatasource"
                    [statuses]="statuses"
                    [isVetEditor]="isVetEditor"
                    [isViewerOnly]="isViewerOnly"
                    (updateStatus)="updateStatus($event)"
                    [openButtonText]="'Image'"
                    [isUserSaleEditor]="isUserSaleEditor"
                    (openButtonClicked)="openImageViewer($event)"
                    (manageButtonClicked)="openImageViewer($event,true)"
                    (downloadButtonClicked)="openXrayDownloaderPopup($event)"
                    [selectAll]="selectAll"
                    (selectionChanged)="updateSelection($event)"></app-review-table>
</div>
<div class="section">
  <app-review-table [headingText]="'VIDEOS'"
                    [datasource]="scopeDatasource"
                    [statuses]="statuses"
                    [isVetEditor]="isVetEditor"
                    [isViewerOnly]="isViewerOnly"
                    (updateStatus)="updateStatus($event)"
                    [openButtonText]="'Video'"
                    [isUserSaleEditor]="isUserSaleEditor"
                    (openButtonClicked)="openVideoModal($event)"
                    (downloadButtonClicked)="openVideoDownloader($event)"
                    [selectAll]="selectAll"
                    (selectionChanged)="updateSelection($event)"></app-review-table>
</div>

<!-- <div class="section" [ngClass]="{ 'disable-container': isLoader }">
  <app-review-table
    [headingText]="'X-Ray Report'"
    [datasource]="reportDatasource"
    [statuses]="statuses$ | async"
    [showStamped]="true"
    (updateStatus)="updateStatus($event)"
    [openButtonText]="'PDF'"
    [isUserSaleEditor]="isUserSaleEditor"
    (openButtonClicked)="openPdf($event)"
  ></app-review-table>
</div> -->

<study-docs-list-table [headingText]="'DOCUMENTS'"
                       [isReadOnly]="!isUserSaleEditor"
                       [statuses]="statuses"
                       [studyFiles]="pdfStudyFiles"
                       [isInReview]="true"
                       [openButtonText]="'Open Images in Viewer'"
                       (openButtonClicked)="openPdf($event)"
                       (downloadButtonClicked)="openDocDownloader($event)"
                       [selectAll]="selectAll"
                       (selectionChanged)="updateSelection($event)"></study-docs-list-table>

<div class="section">
  <div class="row bg-white p-3 mt-2" *ngIf="dataSource">
    <div class="col-md-12 text-center">
      <h5 class="text-primary pb-2">HORSE ACTIVITY HISTORY</h5>
    </div>
    <div class="data-grid bg-gray table-responsive pb-0">
      <table mat-table [dataSource]="dataSource" class="table">
        <ng-container matColumnDef="submittedBy">
          <th mat-header-cell *matHeaderCellDef>Submitted By</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdByUser?.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdDate | date : "medium" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="notes">
          <th mat-header-cell
              class="notes-heading notes-width"
              *matHeaderCellDef>
            Notes
          </th>
          <td mat-cell *matCellDef="let element">{{ element.notes }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns$.value"></tr>
        <tr mat-row
            *matRowDef="
            let row;
            columns: displayedColumns$.value;
            let vetUserIndex = index
          "
            class="pointer"></tr>
      </table>

    </div>
  </div>
</div>
